import { IDashboardContext } from "../../contexts/dashboard-context";
import { isBackgroundColorPanelSupported } from "./background-color-panel/menu-info";
import { isBackgroundPatternPanelSupported } from "./background-pattern-panel/menu-info";

export function isBackgroundPanelSupported(
	spread: eXpress.core.Spread | null | undefined,
	dashboard: IDashboardContext,
) {
	return (
		isBackgroundColorPanelSupported(spread, dashboard) ||
		isBackgroundPatternPanelSupported(spread, dashboard)
	);
}
